import { Power1, TweenMax } from "gsap";
import "gsap/ScrollToPlugin";
import * as $ from "jquery";
$(() => {
  const $window = $(window); // Window object

  const scrollTime = 1.2; // Scroll time
  const scrollDistance = 370; // Distance. Use smaller value for shorter scroll and greater value for longer scroll

  $window.on("mousewheel DOMMouseScroll", event => {
    event.preventDefault();
    if (event.originalEvent) {
      const original = event.originalEvent as Event & {
        wheelDelta: number;
        detail: number;
      };
      const delta = original.wheelDelta / 120 || -original.detail / 3;
      const scrollTop = $window.scrollTop() as number;
      const finalScroll = scrollTop - parseInt(delta * scrollDistance + "", 10);

      TweenMax.to($window, scrollTime, {
        autoKill: true,
        ease: Power1.easeOut,
        overwrite: 5,
        scrollTo: { y: finalScroll, autoKill: true }
        // For more easing functions see https://api.greensock.com/js/com/greensock/easing/package-detail.html
      });
    }
  });
});



// WEBPACK FOOTER //
// ./src/utils/smoothScroll.ts